import styled from 'styled-components';

export const NavigationMenuWrapper = styled.div`
  font-size: 16px;
  line-height: 24px;
  border-bottom: solid 1px #e9ebed;
`;

export const IconWrapper = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
  border-left: solid 1px #c4c4c4;
`;

export const NavigationLabelWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 48px;
  align-items: center;
`;
